import { Phone, Mail, Facebook, Twitter, Linkedin } from "lucide-react";

const TopBar = () => {
  return (
    <div className="bg-foreground text-background py-2 px-4">
      <div className="container mx-auto flex flex-wrap items-center justify-between gap-2 text-sm">
        {/* Contact Info */}
        <div className="flex flex-wrap items-center gap-4">
          <a
            href="tel:+27314648585"
            className="flex items-center gap-2 hover:text-primary transition-colors"
          >
            <Phone className="w-4 h-4" />
            <span>031 464 8585</span>
          </a>

          <a
            href="mailto:info@3acoldrooms.co.za"
            className="flex items-center gap-2 hover:text-primary transition-colors"
          >
            <Mail className="w-4 h-4" />
            <span>info@3acoldroomsandairconditioning.co.za</span>
          </a>
        </div>

        {/* Social Icons */}
        <div className="flex items-center gap-3">
          <a
            href="#"
            className="hover:text-primary transition-colors"
            aria-label="Facebook"
          >
            <Facebook className="w-4 h-4" />
          </a>
          <a
            href="#"
            className="hover:text-primary transition-colors"
            aria-label="Twitter"
          >
            <Twitter className="w-4 h-4" />
          </a>
          <a
            href="#"
            className="hover:text-primary transition-colors"
            aria-label="LinkedIn"
          >
            <Linkedin className="w-4 h-4" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
